import { Extras } from '@sentry/core';

import { ApiError } from './sustain-api-request';

export default function apiErrorToSentryExtras(error: unknown): Extras {
  if (!(error instanceof ApiError)) return {};

  return {
    requestOptions: error.requestOptions,
    responseHeaders: error.response.headers,
    responseData: error.response.data,
  };
}
